/**
 * DEV publicado (Azure): `ng build --configuration=dev` / `ng serve --configuration=dev`.
 */
export const environment = {
  production: false,
  apiUrl: 'https://api-dev.taskeo.io',
  /**
   * URL publica do front (Static Web App / dominio). Alinhar com a variavel cadastrada na Azure no pipeline de build.
   * Vazio = `location.origin` ou `window.__TASKEO_PUBLIC_APP_BASE_URL__` se injetado no deploy.
   */
  publicAppBaseUrl: '',
  /** reCAPTCHA v2 (domínios: dev.taskeo.io, app.taskeo.io na consola Google). */
  recaptchaSiteKey: '6Lehgp4sAAAAAM08_ytvwgb3gSvsQXYfd7GBogeF',
  /** Meta Embedded Signup (WhatsApp) — IDs públicos (App ID + Config ID do Embedded Signup, não são secrets). */
  metaAppId: '2009418639944334',
  metaEmbeddedSignupConfigId: '2365345730653865',
  /** Pagar.me App ID (público) — usado em `POST /core/v5/tokens?appId=...`. Vazio = cartão desabilitado na UI; só Pix. */
  pagarmeAppId: 'pk_test_gAoDgYdiPXCon8mp',
  /** companyId da Taskeo (staff) — ver comentario em `environment.ts`. */
  taskeoStaffCompanyId: '',
};
